import { render, staticRenderFns } from "./TheRemoteDocumentWarning.vue?vue&type=template&id=3c823157"
import script from "./TheRemoteDocumentWarning.vue?vue&type=script&lang=js"
export * from "./TheRemoteDocumentWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports